import React, { Component } from 'react'
import { Upload, message, Button, Icon,Modal } from 'antd';
import * as qiniu from 'qiniu-js'
import request from '../../utils/request'
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import moment from 'moment';
const prexUrl = "https://file.daries.com.cn/"

export default class UploadFile extends Component {

    state = {
        visible:false,
        src: null,
        cropFile:undefined,
        fileName:"",
        crop: {
          unit: "%",
          width: 30,
          aspect: 16 / 9
        }
      };

  static getDerivedStateFromProps(nextProps){
    // Should be a controlled component.
    console.log(nextProps)
    // if ('value' in nextProps) {
    //   let newFileList = nextProps.value.map((item,i) => {
    //     return {
    //       uid:-i,
    //       name:item.name,
    //       status: 'done',
    //       url: item.url,
    //     }
    //   })
    //   return {
    //     ...(nextProps.value || {}),
    //     fileList:newFileList,
    //   };
    // }
    return null;
  }

    constructor(props) {
      super(props);

      const value = props.value || {};
      this.state = {
        fileList:this.convertValueToFileList(value),
      };
    }

    convertValueToFileList = (value) => {
      console.log(value)
      // return value.map((item,i) => {
      //   return {
      //     uid:-i,
      //     name:item.name,
      //     status: 'done',
      //     url: item.url,
      //   }
      // })
    }

    convertFileListToValue = (changedValue) => {
      return changedValue.map((item,i) => {
        return {
          name:item.name,
          url: item.url,
        }
      })
    }    

    triggerChange = changedValue => {
      // Should provide an event to pass value to Form.
      const { onChange } = this.props;
      if (onChange) {
        console.log(this.convertFileListToValue(changedValue));
        onChange(this.convertFileListToValue(changedValue));
      }
    };

    // 处理删除逻辑
    onChange = (info) => {
        let fileList = this.state.fileList;
        if (info.file.status === 'removed') {
          message.error(`${info.file.name} 删除成功`);
          fileList = fileList.filter(item => {
            return item.uid != info.file.uid
          })
          console.log(fileList)
          this.triggerChange(fileList);
        }
    }

    upload = (params) => {
      console.log(params);
      let config = {
        useCdnDomain: true,
        region: qiniu.region.z0
      };
      
      let key = this.props.key
      key = moment().format("YYYYMMDDHHmmssfff") + ".png"
    //   if (this.props.key == undefined){
    //     key = params.file.name
    //   }

      let putExtra = {
        fname: key,
        params: {},
        mimeType: null
      };

      const that = this;
      let newFileList = this.state.fileList;

      if (this.props.isSingle){
          newFileList = [];
      }

      request({
          method:'get',
          url:this.props.tokenUrl,
        }).then(data => {
          var observable = qiniu.upload(params.file, key, data, putExtra, config)
          var observer = {
            next(res){
              console.log("qiniu-next")
              console.log(res)
            },
            error(err){
              console.log("qiniu-err")
              console.log(err)
              message.error(`${params.file.name} 上传失败`);
            }, 
            complete(res){
              console.log("qiniu-complete")
              message.success(`${params.file.name} 上传成功`);

              newFileList.push({
                uid:key,
                name:key,
                url:prexUrl + key,
                status:'done'
              })
              that.triggerChange(newFileList)
            }
          }
          var subscription = observable.subscribe(observer) // 上传开始
        })
    }

    

    beforeUpload = (file,fileList) => {
        return new Promise(resolve => {
            const reader = new FileReader();
            reader.addEventListener("load", () =>
                  this.setState({ src: reader.result,visible:true,fileName:file.name,cropFile:file })
            );
            reader.readAsDataURL(file);
          });
    }

    get uploadProps() {
        let _uploadProps = {
            name: 'file',
            listType: this.props.listType,
            fileList: this.state.fileList,
            customRequest:this.upload,
            onRemove: this.onRemove,
            onChange: this.onChange,
            headers: {
              authorization: 'authorization-text',
            },
        }

        if (this.props.needCrop && this.props.needCrop == true){
            _uploadProps.beforeUpload = this.beforeUpload;
        }

       return _uploadProps;
    }

      render() {
        const { crop, croppedImageUrl, src , visible } = this.state;
        return <div><Upload {...this.uploadProps}>
          <Button>
            <Icon type="upload" /> 上传文件
          </Button>
        </Upload>
        <Modal
            visible={visible}
            onOk={() => {
                this.uploadBlobFile({file:this.state.cropFile});
                this.setState({visible:false})
            }}
            onCancel={() => this.setState({visible:false})}
            >
                {src && (
                    <ReactCrop
                        src={src}
                        crop={crop}
                        ruleOfThirds
                        onImageLoaded={this.onImageLoaded}
                        onComplete={this.onCropComplete}
                        onChange={this.onCropChange}
                    />
                    )}
                    {/* {croppedImageUrl && (
                    <img alt="Crop" style={{ maxWidth: "100%" }} src={croppedImageUrl} />
                    )} */}
            </Modal>
        </div>
      }

    // ########################### crop api ######################
    // If you setState the crop in here you should return false.
    onImageLoaded = (image) => {
        this.imageRef = image;
    };

    onCropComplete = (crop) => {
        this.makeClientCrop(crop);
    };

    onCropChange = (crop, percentCrop) => {
        // You could also use percentCrop:
        // this.setState({ crop: percentCrop });
        this.setState({ crop });
    };

    async makeClientCrop(crop) {
        const fileName = this.state.fileName;
        if (this.imageRef && crop.width && crop.height) {
        const croppedImageUrl = await this.getCroppedImg(
            this.imageRef,
            crop,
            fileName,
        );
        this.setState({ croppedImageUrl });
        }
    }

    getCroppedImg(image, crop, fileName) {
        const canvas = document.createElement("canvas");
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        canvas.width = crop.width;
        canvas.height = crop.height;
        const ctx = canvas.getContext("2d");

        ctx.drawImage(
        image,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width,
        crop.height
        );

        return new Promise((resolve, reject) => {
        canvas.toBlob((blob) => {
            if (!blob) {
            //reject(new Error('Canvas is empty'));
            console.error("Canvas is empty");
            return;
            }

            blob.name = fileName;
            window.URL.revokeObjectURL(this.fileUrl);
            this.fileUrl = window.URL.createObjectURL(blob);
            resolve(this.fileUrl);

            const files = new window.File(
                [blob],
                fileName,
                { type: "image/jpeg" }
            );

            this.setState({cropFile:files})

        }, "image/jpeg");
        });
    }

    uploadBlobFile = (params) => {
        console.log(params);
        let config = {
          useCdnDomain: true,
          region: qiniu.region.z0
        };
        
        let key = this.props.key
        key = moment().format("YYYYMMDDHHmmssfff") + ".png"
        // if (this.props.key == undefined){
        //   key = params.file.name
        // }
  
        let putExtra = {
          fname: key,
          params: {},
          mimeType: null
        };
  
        const that = this;
        let newFileList = this.state.fileList;
  
        if (this.props.isSingle){
            newFileList = [];
        }
  
        request({
            method:'get',
            url:this.props.tokenUrl,
          }).then(data => {
            var observable = qiniu.upload(params.file, key, data, putExtra, config)
            var observer = {
              next(res){
                console.log("qiniu-next")
                console.log(res)
              },
              error(err){
                console.log("qiniu-err")
                console.log(err)
                message.error(`${params.file.name} 上传失败`);
              }, 
              complete(res){
                console.log("qiniu-complete")
                message.success(`${params.file.name} 上传成功`);
  
                newFileList.push({
                  uid:key,
                  name:key,
                  url:prexUrl + key,
                  status:'done'
                })
                that.triggerChange(newFileList)
              }
            }
            var subscription = observable.subscribe(observer) // 上传开始
          })
      }
}


// WEBPACK FOOTER //
// ./src/components/Upload/UploadQiniu.js